import React from "react"
import Resume from "./assets/resume/Daniel Brestoiu - Resume.pdf"

// TODO: Import better or smarter and hopefully get rid of name.(something).pdf
export default function ResumePage() {
  return (
    <iframe src={Resume} style={{ minHeight: "120vh", width: "100%", border: "0px" }} title={"Daniel Brestoiu Resume"} />
  )
}
